/**
 * Lazy load videos
 *
 * @see https://web.dev/lazy-loading-video/
 */
document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll('.js-bg--type-video video'));

  // @todo handle no intersection observer
  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {

          // lazyload
          if (!video.target.classList.contains('is-loaded')) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
            video.target.load();
            video.target.classList.add('is-loaded');
            //lazyVideoObserver.unobserve(video.target);
          }


          // // parallax
          // if (video.boundingClientRect.top > 0) {

          //   console.log('below', video.boundingClientRect.top);
          // } else {
          //   console.log('above', video.boundingClientRect.top);
          // }


        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px', // important: needs units on all values
      threshold: 0
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

/**
 * Parallax
 */
document.addEventListener('scroll', () => {

  const scrollPosition = window.pageYOffset;
  const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

  const bgs = document.querySelectorAll('.js-bg');
  bgs.forEach((bg) => {
    const background = bg.querySelector('.js-bg__background__media');
    if (background) {

      // compensate if element is shorter than screen
      let shortHeightCompensation = 0;
      if (bg.offsetHeight < viewportHeight) {
        shortHeightCompensation = viewportHeight - bg.offsetHeight;
      }

      let beforeOnScreenOffset = (bg.offsetTop - viewportHeight > 0) ? bg.offsetTop - viewportHeight : 0;
      let afterOnScreenOffset = bg.offsetTop + bg.offsetHeight + viewportHeight;

      // while element is on screen but the elemetns top and bottom are not both visible
      if (scrollPosition >= beforeOnScreenOffset && scrollPosition <= afterOnScreenOffset) {

        // bail if element fits entirely to screen
        if (scrollPosition + viewportHeight > bg.offsetTop + bg.offsetHeight && bg.offsetHeight < viewportHeight) {
          background.style.transform = 'translateY(0)';
        } else {
          let offSetToViewport = 0;
          if (scrollPosition <= bg.offsetTop) {
            offSetToViewport = bg.offsetTop - scrollPosition - (shortHeightCompensation);
          } else {
            offSetToViewport = (scrollPosition - bg.offsetTop) / -1;
          }

          // cap offset to element height if element is shorter or equal to viewport
          offSetToViewport = (offSetToViewport > bg.offsetHeight && bg.offsetHeight <= viewportHeight) ? bg.offsetHeight : offSetToViewport;

          // the big parallax effect
          background.style.transform = 'translateY(' + (parseInt(offSetToViewport) / -1) + 'px)';

        }

      } else {
        background.style.transform = 'translateY(0)';
      }

    }
  });

});
